/**
 * A global namespace for `keyup` event.
 */
const keyupEvent = 'keyup';
export default keyupEvent;
